<template>
  <div v-if="loading">
    <div>
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb40 text-center">
              <h1>Corsi Acquistabili</h1>
            </div>
          </div>
          <div class="row">
            <div v-for="course in courses" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <!-- team-img -->
              <div class="team-block">
                <div class="team-img">
                  <img :src="course.image" alt="">
                  <!-- <div class="team-content">
                    <h4 class="text-white mb0">{{ course.title }}</h4>
                    <p class="team-meta">- {{ course.teacher.name }}</p>
                  </div> -->
                  <div class="overlay">
                    <div class="text">
                      <h4 class="mb0 text-white">{{ course.title }}</h4>
                      <p class="mb30 team-meta">- {{ course.teacher.name }}</p>
                      <p>{{ course.tldr }}</p>
                      <router-link class="btn btn-outline-primary" :to="{ name: 'CourseDetail', params: { id: course.id }}">Dettagli</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="canCreateCourses" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <!-- team-img -->
              <div class="team-block">
                <div class="team-img" static="true">
                  <img src="https://placehold.it/300x300" alt="">
                  <div class="team-content">
                    <h4 class="text-white mb0">Crea un corso</h4>
                  </div>
                  <div class="overlay">
                    <div class="text">
                      <h4 class="mb0 text-white">Crea un corso</h4>
                      <p>Sei un insegnante che vuole condividere la propria esperienza con gli altri? Questo e' il modo giusto per farlo, crea un corso!</p>
                      <router-link class="btn btn-outline-primary" :to="{ name: 'CourseAdd'}">Crealo!</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-5" v-else>
    <div class="loader"></div>
  </div>
</template>

<script>
import { firebase, database, storage } from '@/firebase'
import { getCurrentUser, permissions } from '@/helpers'
import { router } from '@/router'

export default {
  name: 'Projects',
  data() {
    return {
      courses: [],
      canCreateCourses: false,
      loading: false
    }
  },
  created(){
    let currentFirebaseUser = firebase.auth().currentFirebaseUser
    if (currentFirebaseUser) {
      getCurrentUser(currentFirebaseUser.email)
        .then(user => {
          if (user.accessLevel != permissions.guest)
            this.canCreateCourses = true
        })
    }

    database.collection("Courses").get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let course = { ...doc.data(), id: doc.id }
        course.teacher.get().then(tDoc => {
          course.teacher = tDoc.data()
          storage.child("Courses/"+course.id+"/profile").getDownloadURL().then(url => {
            course.image = url;
            this.courses.push(course)
            this.loading = true;
          })
        })
      });
    })
  }
}
</script>

<style scoped>
body {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: "Lato", sans-serif;
  letter-spacing: 0px;
  font-size: 16px;
  color: #62686c;
  font-weight: 400;
  line-height: 28px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 300;
  color: #11181f;
  margin: 0px 0px 15px 0px;
  font-family: "Lato", sans-serif;
}
h1 {
  font-size: 44px;
}
h2 {
  font-size: 38px;
}
h3 {
  font-size: 24px;
  font-weight: 400;
}
h4 {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
}
h5 {
  font-size: 16px;
  font-weight: 400;
}
h6 {
  font-size: 12px;
  font-weight: 400;
}
p {
  margin: 0 0 20px;
  line-height: 1.7;
}
p:last-child {
  margin: 0px;
}
a {
  text-decoration: none;
  color: #62686c;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}
a:focus,
a:hover {
  text-decoration: none;
  color: #f67800;
}

.content {
  padding-top: 80px;
  padding-bottom: 80px;
}
.mb40 {
  margin-bottom: 40px;
}
.team-block {
  margin-bottom: 20px;
}
.team-content {
  position: absolute;
  background-color: rgba(17, 24, 31, 0.8);
  bottom: 0px;
  display: inline-block;
  width: 100%;
  color: #fff;
  padding: 30px;
}
.team-img {
  position: relative;
}
.team-img img {
  width: 100%;
}
.team-meta {
  color: #9da4aa;
  font-weight: 400;
  font-size: 16px;
}
.overlay {
  border-radius: 0px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  background-color: #11181f;
}
.team-img:hover .overlay {
  opacity: 0.8;
}
.team-img:hover .team-content {
  opacity: 0;
}
.text {
  color: #fff;
  position: absolute;
  top: 30%;
  left: 30%;
  transform: translate(-26%, -26%);
  -ms-transform: translate(-26%, -26%);
  right: 0;
  font-weight: 400;
  font-size: 16px;
}
.text .btn.btn-outline-primary {
  color: white;
}
.loader {
  border: 4px solid #f3f3f3;
  border-radius: 100%;
  border-top: 4px solid #46484c;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 0.5s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/Courses.vue